<template>
    <v-form
            ref="modifyContractForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
        <div class="of-y">
            <div class="d-flex align-center primary pl-3 pr-2">
                <div class="flex-grow-1 sub--text">
                    {{contract.id ? 'Edit Contract' : 'Create Contract'}}
                </div>
                <div v-if="!contract.id">
                    <v-btn
                            icon
                            color="white"
                            small
                            @click="$emit('dismiss')"
                    >
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-divider></v-divider>
            <div class="pb-1">
                <div class="flex-grow-1 of-y px-2 pb-1">
                    <v-text-field
                            label="Contract Name"
                            hide-details="auto"
                            v-model="contract.description"
                            @input="changesMade = true"
                            :rules="[validationRules.required, validationRules.notNull, duplicateContractName]"
                            :error-messages="contractNameErrorMessages"
                    />
                </div>

                <div class="flex-grow-1 px-2 pb-1 " v-if="contract.fkContractDoc && viewValue">

                    <div class="pb-1 caption grey--text text--darken-2 pt-3">
                        Contract Document
                    </div>

                    <div class="d-flex align-center justify-space-around">
                        <v-btn
                                color="primary"
                                small
                        >
                            Preview Contract
                        </v-btn>
                        <v-btn
                                color="primary"
                                small
                                @click="viewValue = false"
                        >
                            Upload New Contract
                        </v-btn>
                    </div>


                </div>

                <div class="flex-grow-1 of-y px-2 pb-1" v-else>
                    <v-file-input
                            label="Word Contract"
                            hide-details="auto"
                            v-model="contractFile"
                            @input="changesMade = true"
                            :rules="[validationRules.required, validationRules.notNull]"
                    />
                </div>

                <div class="flex-grow-1 d-flex flex-column of-y pb-1 of-y" style="max-height: 400px">
                    <div style="position: sticky; top: 0; z-index: 9" class="px-2 white">
                        <div class="caption grey--text text--darken-2 pt-3">
                            Contract Annexures
                        </div>
                        <div slot="header" class="px-2 py-2">
                            <v-btn
                                    small
                                    block
                                    color="primary"
                                    @click="addAnnexure"
                            >
                                <v-icon left>mdi-plus</v-icon>
                                Add Annexure
                            </v-btn>
                        </div>
                    </div>


                    <v-list
                            dense
                    >
                        <v-list-item v-for="item in contract.content" :key="item.id" @click="() => {}">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span v-if="item.description">
                                        {{item.description}}
                                    </span>
                                    <span v-else class="error--text text-overline">
                                        No Description
                                    </span>
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action class="pa-0 ma-0 ">
                                <div class="d-flex align-center">
                                    <v-tooltip top z-index="10">
                                        <template v-slot:activator="{on}">
                                            <v-btn
                                                    icon
                                                    small
                                                    color="error"
                                                    class="mx-1"
                                                    @click="arrSplice(contract.content, (ann) => ann.id === item.id)"
                                                    v-on="on"
                                            >
                                                <v-icon>mdi-trash-can</v-icon>
                                            </v-btn>
                                        </template>
                                        Delete Annexure
                                    </v-tooltip>
                                    <v-tooltip top z-index="10">
                                        <template v-slot:activator="{on}">
                                            <v-btn
                                                    icon
                                                    small
                                                    color="primary"
                                                    class="mx-1"
                                                    @click="editAnnexure(item)"
                                                    v-on="on"
                                            >
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        Edit Annexure
                                    </v-tooltip>
                                </div>

                            </v-list-item-action>
                        </v-list-item>
                    </v-list>

<!--                    <multi-select-list-->
<!--                            class="flex-grow-1 of-y"-->
<!--                            :items="annexures"-->
<!--                            itemKey="id"-->
<!--                            :showCheckBoxes="true"-->
<!--                            :multiple="false"-->
<!--                            headlineKey="description"-->
<!--                            v-model="selectedAnnexure"-->
<!--                            filterLabel="Filter Annexures"-->
<!--                    >-->



<!--                    </multi-select-list>-->



                    <div
                            style="position: sticky; bottom: 0"
                            class="pa-1 text-center text-overline error--text white"
                            v-if="Array.isArray(contract.content) && contract.content.length === 0"
                    >
                        A minimum of one annexure is required
                    </div>
                </div>


                <div class="text-right pr-2 pb-1 pt-2">
                    <v-btn
                            @click="validateSave()"
                            fab
                            small
                            color="secondary"
                            :loading="loading"
                            :disabled="!changesMade || loading"
                    >
                        <v-icon v-if="!loading">mdi-content-save</v-icon>
                    </v-btn>
                </div>

                <annexure-editor
                        v-if="showEditAnnexure"
                        :annexure="selectedAnnexure"
                        @close="showEditAnnexure = false"
                        @input="updateSelectedWithEditor"
                ></annexure-editor>
            </div>
        </div>

        <v-progress-linear
                v-if="showUpload"
                ref="upload"
                :value="uploadProgress"
                :indeterminate="showUpload && uploadProgress === null"
        ></v-progress-linear>
    </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {arrSplice, generateRandomId, validationRules} from "../../../core/codeFunctions";
import MultiSelectList from "@/components/General/Multi Select List/MultiSelectList";
import AnnexureEditor from "@/components/Setup/Contracts/AnnexureEditor";
import {newReqUpload} from "@/core/request";

export default {
    components: {AnnexureEditor, MultiSelectList},
    props: {
        editContract: Object
    },
    data() {
        return {
            arrSplice,
            contract: {
                id: null,
                content: [],
                description: null,
                fkContractDoc: null
            },
            contractNameErrorMessages: null,
            loading: false,
            validationRules: validationRules,
            changesMade: false,
            contractFile: null,
            viewValue: true,
            selectedAnnexure: null,
            showEditAnnexure: false,
            annexures: [{
                id: generateRandomId(),
                description: null,
                body: "..."
            }],
            selectedFarm: null,
            uploadProgress: null,
            showUpload: false
        }
    },
    watch: {
        editContract: {
            deep: true,
            immediate: true,
            handler(val) {
                console.log({val})
                this.changesMade = false
                this.viewValue = true
                this.contract = JSON.parse(JSON.stringify(val))
            }
        },
        "contract.description"() {
            this.contractNameErrorMessages = null
        },
    },
    methods: {
        duplicateContractName(val) {
            if (!val) {
                return "A description is required"
            }
            if (this.contracts.find(contract => contract.id !== this.editContract.id && this.contract.description === contract.description)) {
                return "Duplicate contract name"
            }
            return true
        },
        addAnnexure() {
            this.contract.content.push({
                id: generateRandomId(),
                description: null,
                body: "..."
            })
            this.selectedAnnexure = this.contract.content[this.contract.content.length - 1]
            this.showEditAnnexure = true
        },
        updateSelectedWithEditor(e) {
            this.selectedAnnexure.description = e.description
            this.selectedAnnexure.body = e.body
            this.changesMade = true
        },
        editAnnexure(e) {
            this.selectedAnnexure = e
            this.showEditAnnexure = true
        },
        async validateSave() {

            if (!this.$refs.modifyContractForm.validate())
                return false
            if (!this.contract.content.length) {
                return this.$snack.error("At least one annexure is required")
            }
            for (const ann of this.contract.content) {
                if (!ann.description) {
                    return this.$snack.error("Invalid annexure name")
                } else if (!ann.body.includes("[Employee Table]")) {
                    return this.$snack.error(`${ann.description} has no [Employee Table]`)
                }
            }


            if (this.contractFile && !this.contract.fkContractDoc && this.viewValue) {
                try {
                    this.loading = true
                    const vm = this
                    this.showUpload = true;
                    const dbFile = await this.$newReqUpload(
                            "POST",
                            "setup/contract/uploadDoc",
                            this.contractFile,
                            "contract",
                            true,
                            (e) => {
                                const progress = Math.round((e.loaded / e.total) * 100)
                                vm.uploadProgress = progress >= 100 ? null : progress
                            }
                    )
                    this.contract.fkContractDoc = dbFile.id
                    this.showUpload = false;
                } catch (e) {
                    this.showUpload = false;
                    this.loading = false
                    return this.$snack.netWorkError()
                }
            }

            this.$emit('save', {contract: this.contract, ref: this})
        }
    },
    computed: {
        ...mapGetters(['contracts', 'farms'])
    },
}
</script>

<style scoped>

</style>